<template>
  <v-app id="login" class="primary">
    <v-main>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <img
                    src="/static/logo/fg-logo.svg"
                    alt="FG Payment"
                    width="120"
                    height="120"
                  />
                  <h1 class="flex my-4 primary--text">
                    {{ $t("login.title") }}
                  </h1>
                  <lang-select></lang-select>
                </div>
                <v-form name="loginForm" ref="loginForm" :model="loginForm">
                  <v-text-field
                    autocomplete="on"
                    append-icon="person"
                    name="email"
                    :label="$t('common.email')"
                    type="email"
                    v-model="loginForm.email"
                  ></v-text-field>
                  <v-text-field
                    append-icon="lock"
                    name="password"
                    :label="$t('common.password')"
                    id="password"
                    type="password"
                    v-model="loginForm.password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
              <router-link to="forgot-password">{{
                  $t("login.forgotPassword")
                  }}</router-link>
                <v-spacer></v-spacer>
                <v-btn width="200" color="primary" @click="login" :loading="loading"
                  >{{ $t("button.login") }}
                </v-btn>
              </v-card-actions>

<!--              <div-->
<!--                class="register"-->
<!--                fxlayout="column"-->
<!--                fxlayoutalign="center center"-->
<!--                style="flex-direction: column; box-sizing: border-box; display: flex; place-content: center; align-items: center;"-->
<!--              >-->
<!--                <span class="text">{{ $t("login.dontHaveAccount")}}</span>-->
<!--                <router-link to="register">{{-->
<!--                  $t("button.createAnAccount")-->
<!--                }}</router-link>-->
<!--              </div>-->
            </v-card>
          </v-flex>
          <v-snackbar
            :timeout="3000"
            :bottom="snackbar.y === 'bottom'"
            :top="snackbar.y === 'top'"
            :multi-line="snackbar.mode === 'multi-line'"
            right
            :color="snackbar.color"
            v-model="snackbar.show"
          >
            {{ snackbar.text }}
            <v-btn dark text @click.native="snackbar.show = false" icon>
              <v-icon>close</v-icon>
            </v-btn>
          </v-snackbar>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { validateEmail } from "@/util/validate";
import { setToken } from "@/util/auth";
import LangSelect from "@/components/LangSelect";

export default {
  name: "Login",
  components: {
    LangSelect
  },
  data() {
    const checkEmail = (rule, value, callback) => {
      if (!validateEmail(value)) {
        callback(new Error("Please enter the correct email"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("The password can not be less than 6 digits"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      loginForm: {
        email: "",
        password: ""
      },
      loginRules: {
        email: [{ required: true, trigger: "blur", validator: checkEmail }],
        password: [
          { required: true, trigger: "blur", validator: validatePassword }
        ]
      },
      redirect: undefined,
      snackbar: {
        show: false,
        text: "",
        color: ""
      }
    };
  },
  methods: {
    login() {
      this.loading = true;

      this.$store
        .dispatch("LoginByEmail", this.loginForm)
        .then(() => {
          this.loading = false;
          this.snackbar = {
            show: true,
            color: "green",
            text: "Login successfully."
          };
          this.$router.push({ path: this.redirect || "/dashboard" });
        })
        .catch(() => {
          this.snackbar = {
            show: true,
            color: "red",
            text: "The email or password is invalid."
          };
          this.loading = false;
        });
    },
    autoLogin(route) {
      let token = {
        "access-token": route.query["access-token"],
        expiry: route.query["expiry"],
        "token-type": route.query["token-type"],
        uid: route.query["uid"],
        client: route.query["client"]
      };
      setToken(token);
      this.$router.push({ path: this.redirect || "/dashboard" });
    }
  },
  created() {
    let route = this.$route;
    if (route.query && route.query["access-token"]) {
      this.autoLogin(route);
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    }
  }
};
</script>
<style scoped lang="css">
#login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
}

.v-card__actions .v-btn {
    margin: 0;
    min-width: 56px;
}
</style>
